import { appConfig } from "../../config";

export const apiUrl = appConfig.apiHost || "https://admin.stripperfans.com/api/user/";
export const utilitiesServiceUrl = appConfig.utilitiesHost || "https://utilities.stripperfans.com/";
